import React, { Component } from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Calendar from "./Calendar"


const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    grow: {
        flexGrow: 1,
    },
    centerText: {
        textAlign: 'center'
    },
});

class MainHome extends Component {
    constructor(){
        super();
        this.state = {
          
        }
    }

    render(){
        const { classes } = this.props;

        return(
            <div className={classes.root}>
                <Grid container spacing={24}>
                    <Grid item xs={2} className={classes.centerText}>

                    </Grid>
                    <Grid item xs={8} className={classes.centerText}>
                       <Calendar/>
                    </Grid>  
                    <Grid item xs={2} className={classes.centerText}>

                    </Grid>
                                                        
                </Grid>
                
            </div>
        );
    }
}

MainHome.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MainHome);